// extracted by mini-css-extract-plugin
export default {"menuBlock":"UE-z","title":"VE-z","nav":"WE-z","flexCell":"XE-z","facetLink":"YE-z"};